<template>
  <div>
    <!-- on-ok="handleOk" :closable="false" -->
    <a-modal v-model="viewModal" :width="1500" title="Import Update Alumni Achivement" :closable="false"
      :maskClosable="false">
      <template slot="footer">
        <a-button @click="onCloseDataModal"> close </a-button>
        <a-button @click="onSubmitImport" :loading="!isLoaded" type="primary">
          Submit Upload
          <!-- {{ countInsert }} -->
        </a-button>
      </template>
      <!-- {{ fileList }} -->
      <h6 class="mt-5 mb-10">
        Input Data
        <p class="mt-0 mb-0">
          Example file :
          <a target="_blank"
            href="https://docs.google.com/spreadsheets/d/1yfYmfvyAot_1u1z23zDdtQP2f2HFbazY3uyUnVEXFH8/edit?usp=sharing">File
            (.xlsx)</a>
        </p>
      </h6>
      <a-upload-dragger name="file" :file-list="fileList" @change="handleChange">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">Click or drag file to this area to upload</p>
      </a-upload-dragger>
      <br />
      <!-- <div class="modal-info"> -->

      <a-row>
        <a-col :span="4">
          <a-tag color="green">
            <p class="text-center mt-5 mb-0 font-bold">
              Alumni
              <span class="text-danger">{{ dataTable.length }}</span> person
            </p>
          </a-tag>
        </a-col>
        <a-col :span="16">
          <span v-if="!isLoaded">
            <a-progress :stroke-color="{
              from: '#108ee9',
              to: '#87d068',
            }" :percent="importProgress" status="active" />
          </span>
        </a-col>
        <a-col :span="4" style="text-align:right">
          <a-tag color="blue">
            <p class="text-center mt-5 mb-0 font-bold">
              Complete :
              <span class="text-info">{{ importComplete }}</span>
            </p>
          </a-tag>
          <a-tag color="red">
            <p class="text-center mt-5 mb-0 font-bold">
              Failed :
              <span class="text-danger">{{ importFailed }}</span>
            </p>
          </a-tag>
        </a-col>
      </a-row>


      <a-table bordered :columns="columns" :data-source="dataTable" :loading="loadingSetTable" :pagination="true"
        size="small" class="mt-20 mb-20" :scroll="{ x: 1500 }">
        <template slot="status_import" slot-scope="text, record, index">
          <div>
            <a-icon :style="{ fontSize: '25px', color: '#F55050' }" v-if="text === 'error'" type="exclamation-circle" />
            <a-icon :style="{ fontSize: '25px', color: '#1F8A70' }" v-if="text === 'complete'" type="check-square" />
          </div>
        </template>

        <template slot="status_detail" slot-scope="text, record, index">
          <span v-if="record.status_import === 'error'">
            <p :style="{ color: '#F55050' }">{{ text }}</p>
          </span>
          <span v-if="record.status_import === 'complete'">
            <p :style="{ color: '#1F8A70' }">Import Complete</p>
          </span>
        </template>

        <template slot="subscribe" slot-scope="text, record, index">
          <!-- {{ record.subscribe }} -->
          <div v-if="record.subscribe">
            <a-icon type="check" />
          </div>
          <div v-else>
            <a-icon type="minus" color="warning" />
          </div>
        </template>
      </a-table>
      <!-- </div> -->
      <p class="mt-0 mb-0">{{ indexLoad }}</p>
    </a-modal>
  </div>
</template>

<script>
import readXlsxFile from "read-excel-file";
import _tableUpload from "./table-import/tableImportAlumniAchievement";

export default {
  props: {
    viewModal: {
      type: Boolean,
      default: false,
    },
    onCloseModal: {
      type: Function
    }
  },
  data() {
    return {
      // table connect api status
      indexLoad: "",
      processImport: [],
      indexErrorName: [],
      indexErrorContact: [],
      //
      dataTable: [],
      columns: _tableUpload.excleHead,
      // file upload
      fileList: [],
      uploading: false,
      errorFile: "",
      loading: false,
      // option
      optionCountry: [],
      optionTypeGraduate: [],
      //
      arrName: [],
      arrNameFormer: [],
      arrContact: [],
      arrContactFormer: [],
      loadingSetTable: false,
      startInsertName: false,
      // count load
      countInsert: 0,
      //loading
      isLoaded: true,
      //amount import
      importComplete: 0,
      importFailed: 0
    };
  },
  mounted() {
    this.getDataOptions();
  },
  computed: {
   importProgress() {
      return  Number.parseFloat((this.importComplete + this.importFailed) * 100 / this.dataTable.length).toFixed(2);
    }
  },
  methods: {
    async getDataOptions() {
      const fetchType = await this.$http.get(
        `/student_affair/education-graduate/`
      );
      const fetchCountry = await this.$http.get(
        `/student_affair/country-of-citizenship/`
      );
      Promise.all([fetchCountry, fetchType])
        .then((response) => {
          return Promise.all(response.map((r) => r.data));
        })
        .then(([listA, listB]) => {
          this.optionCountry = listA.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionTypeGraduate = listB.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
        })
        .catch((error) => {
          this.$emit("errorNotification", {
            errorMsg: error.response.status,
            urlPath: `fail call option list`,
          });
        });

    },
    onCloseDataModal() {
      this.fileList = [];
      this.dataTable = []
      this.onCloseModal();
      // (this.dataTable = []), this.$emit("hideModal");
    },
    checkBlank(val) {
      return !["", null, "null"].includes(val) ? val : "-";
    },
    // convertDateNumberToString(excelDate) {
    //   const { getJsDateFromExcel } = require("excel-date-to-js");
    //   return this.moment(new Date(getJsDateFromExcel(excelDate))).format(
    //     "YYYY-MM-DD"
    //   );
    // },
    handleChange(info) {
      this.loadingSetTable = true;
      this.importComplete= 0
      this.importFailed= 0
      this.dataTable = [];
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      this.processImport = [];

      // 2. read from response and show file link
      fileList = fileList.map((file) => {
        if (file.response) {
          let xlsxfile = info.file.originFileObj;
          readXlsxFile(xlsxfile).then((rows) => {
            for (let index = 0; index < rows.length; index++) {
              this.processImport.push({
                index: index,
                status: "wait",
                student_id: rows[index][3],
              });
              if (index > 1) {
                this.dataTable.push({
                  // status import
                  status_import: "",
                  //describe
                  status_detail: "",
                  // not use
                  sequence: index, // not use
                  // not use
                  student_id: rows[index][1],
                  name_of_award_scholarship: this.checkBlank(rows[index][2]),
                  date_of_recive: rows[index][3] !== ""
                    ? this.convertDateNumberToString(rows[index][3])
                    : "",
                  organized_by_granted_by: this.checkBlank(rows[index][4]),
                  location_and_country: this.checkBlank(rows[index][5]),
                  type_award: this.checkBlank(rows[index][6]),
                });
              }
            }
          });
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
      this.loadingSetTable = false;
    },
    updateMainProfile(jsonData, id) {
      return new Promise((resolve) => {
        this.$http
          .patch(
            "/student_affair/alumni-profile/" + id + "/",
            jsonData
          )
          .then((response) => {
            if (response.status) {
              resolve(true);
            }
          })
          .catch((error) => {
            //console.log(error);
            resolve(false);
          });
      });
    },
    getStudentProfile(studentID) {
      return new Promise((resolve) => {
        this.$http
          .get(
            "student_affair/alumni-profile/?student_id=" + studentID)
          .then((response) => {
            if (response.status == 200 & response.data.length > 0) {
              //console.log("std ID " + studentID);
              resolve(response.data);
            } else {
              resolve([]);
            }
          })
          .catch((error) => {
            //console.log(error);
            resolve([]);
          });
      });
    },
    async onSubmitImport() {
      //console.log(this.dataTable.length)
      this.isLoaded = false;
      for (let i = 0; i < this.dataTable.length; i++) {
        let recData = this.dataTable[i];
        let dataProfile = await this.getStudentProfile(recData['student_id']);
        if (dataProfile.length > 0) {
          let studentProfile = dataProfile[0]
          this.dataTable[i]['status_import'] = 'complete'
          try {
            //map key value
            let jsonAchievement = {
              type_award: recData['type_award'],
              organized_by_granted_by: recData['organized_by_granted_by'],
              name_of_award_scholarship: recData['name_of_award_scholarship'],
              location_and_country: recData['location_and_country'],
              date_of_recive: recData['date_of_recive'],
              alumni_profile: studentProfile['id'],
            };
            //console.log(jsonAchievement)
            const response = await this.$http.post(
              "/student_affair/alumni-award/",
              jsonAchievement
            );
            if (response.status === 201) {
              this.dataTable[i]['status_import'] = 'complete'
              this.importComplete++
            } else {
              throw { response };
            }
          } catch (error) {
            //console.log(error)
            this.dataTable[i]['status_import'] = 'error'
            this.dataTable[i]['status_detail'] = 'Update educaiton error.'
            this.importFailed++
          }
        } else {
          this.dataTable[i]['status_import'] = 'error'
          this.dataTable[i]['status_detail'] = 'Student ID not found.'
          this.importFailed++
        }
      }
      this.isLoaded = true;
    },
    convertDateNumberToString(excelDate) {
      const { getJsDateFromExcel } = require("excel-date-to-js");
      var dateConvert = ""
      try {
        dateConvert = this.moment(new Date(getJsDateFromExcel(excelDate))).format(
          "YYYY-MM-DD"
        )
      } catch (e) {
        dateConvert = this.moment(new Date(excelDate)).format(
          "YYYY-MM-DD"
        );
      }
      return dateConvert;
    },
       mapDataOptions(arr, value) {
      let result = "";
      let filterObj = arr.filter(
        (item) => item.textEn.toLowerCase() === value.toLowerCase()
      );
      try {
        if (filterObj.length === 0) {
          let filterObjB = arr.filter(
            (item) => item.textEn.toLowerCase() === "-"
          );
          result = filterObjB[0].id;
        } else {
          result = filterObj[0].id;
        }
      } catch (e) {
      }
      return result
    },
  },
};
</script>
<style>
.modal-info {
  overflow-y: scroll;
  max-height: 500px;
}
</style>